import React from "react";
import { 
  CDBBtn,
  CDBView,
  CDBIframe, } from "cdbreact";
import { Layout } from "../Layout";
import { TemplateNav } from "../TemplateNav";
import Sidebar from "../Sidebar";


export const Card = () => {
  return (
    <div className="d-flex w-100">
      <div style={{height:"100vh", overflow:"hidden initial"}}>
        <Sidebar/>
      </div>
      <Layout>
        <TemplateNav/>
    <div className="r-w">
      <div className="blockcode">
        <div className="header">Basic</div>
        <div className="description">Basic cards</div>
        <div className="example2">
          <div className="border d-flex flex-column" style={{ maxWidth: "25rem" }}>
            <img
              alt="cardImg"
              className="img-fluid"
              src="/img/cardbg.png"
            />
            <div className="p-3">
              <h3>Basic</h3>
              <p>This is just a card text Get important notifications about you or activity you've missed </p>
              <CDBBtn>
                Button
                </CDBBtn>
            </div>
          </div>
        </div>
      </div>
      <div className="blockcode">
        <div className="header">Profile</div>
        <div className="description">Profile display card</div>
        <div className="example2">
          <div className="border d-flex flex-column" style={{ maxWidth: "25rem" }}>
            <img
              alt="cardImg"
              className="img-fluid"
              src="/img/cardbg.png"
            />
            <img alt="cardImg" className="mx-auto border rounded-circle" style={{marginTop:"-5rem"}} width="130px" src="/img/pane/pane4.png" />
            <div className="p-3 d-flex flex-column align-items-center mb-4">
              <h4 style={{fontWeight:"600"}}>Sammy Russo</h4>
              <p>Senior Software Developer</p>
              <p className="text-muted">Detroit, USA</p>
              <div>
                <CDBBtn size="small" color="dark"><i className="fas fa-user-plus"></i>Connect</CDBBtn>
                <CDBBtn className="ml-3" size="small" color="warning"> Send Message </CDBBtn>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="blockcode">
        <div className="header">Simple</div>
        <div className="description">Simple cards</div>
        <div className="example2">
          <div className="border d-flex flex-column" style={{ maxWidth: "25rem" }}>
            <div className="p-3">
              <h4 className="mt-3">Heading</h4>
              <p>Paragraph</p>
              <div className="d-flex justify-content-center">
                <CDBBtn color="light" flat circle>
                  Button
                </CDBBtn>
              </div>
            </div>
          </div>
          <div className="border d-flex flex-column" style={{ maxWidth: "25rem" }}>
            <div className="p-3">
              <h4 className="mt-3">Heading</h4>
              <p>Paragraph</p>
              <CDBBtn color="light" flat block>
                Button
              </CDBBtn>
            </div>
          </div>
          <div className="border d-flex flex-column" style={{ maxWidth: "25rem" }}>
            <div className="p-3">
              <h4 className="mt-3">Heading</h4>
              <p>Paragraph</p>
              <CDBBtn color="light" flat circle>
                Button
              </CDBBtn>
            </div>
          </div>
        </div>
      </div>
      <div className="blockcode">
        <div className="header">Bodered</div>
        <div className="description">Bodered cards</div>
        <div className="example2">
          <div className="border d-flex flex-column" style={{ maxWidth: "25rem" }} border>
            <div className="p-3">
              <h4 className="mt-3">Heading</h4>
              <p>Paragraph</p>
              <div className="d-flex justify-content-center">
                <CDBBtn color="light" flat circle>
                  Button
                </CDBBtn>
              </div>
            </div>
          </div>
          <div className="border d-flex flex-column" style={{ maxWidth: "25rem" }} border>
            <div className="p-3">
              <h4 className="mt-3">Heading</h4>
              <p>Paragraph</p>
              <CDBBtn color="light" flat block>
                Button
              </CDBBtn>
            </div>
          </div>
          <div className="border d-flex flex-column" style={{ maxWidth: "25rem" }}>
            <div className="p-3 text-right">
              <h4 className="mt-3">Heading</h4>
              <p>Paragraph</p>
              <CDBBtn color="light" flat className="w-100" circle>
                Button
              </CDBBtn>
            </div>
          </div>
        </div>
      </div>
      <div className="blockcode">
        <div className="header">Artwork top</div>
        <div className="description">Artwork top cards</div>
        <div className="example2">
          <div className="border d-flex flex-column" style={{ maxWidth: "25rem" }}>
            <img
              alt="cardImg"
              className="img-fluid"
              src="/img/cardbg.png"
            />
            <div className="p-3">
              <h4 className="mt-3">Heading</h4>
              <p>Paragraph</p>
              <div className="d-flex justify-content-center">
                <CDBBtn color="light" flat block circle>
                  Button
                </CDBBtn>
              </div>
            </div>
          </div>
          <div className="border d-flex flex-column" style={{ maxWidth: "25rem" }}>
            <img
              alt="cardImg"
              className="img-fluid"
              src="/img/cardbg.png"
            />
            <div className="p-3">
              <h4 className="mt-3">Heading</h4>
              <p>Paragraph</p>
              <CDBBtn color="light" flat circle>
                Button
              </CDBBtn>
            </div>
          </div>
        </div>
      </div>
      <div className="blockcode">
        <div className="header">Artwork middle</div>
        <div className="description">Artwork middle cards</div>
        <div className="example2">
          <div className="border d-flex flex-column" style={{ maxWidth: "25rem" }}>
            <div className="p-3">
              <h4 className="mt-3">Heading</h4>
              <p>Paragraph</p>
            </div>
            <CDBView>
              <CDBIframe src="https://www.youtube.com/embed/xnczyP2jSR0"></CDBIframe>
            </CDBView>
            <div className="p-3">
              <CDBBtn color="light" flat circle>
                Button
              </CDBBtn>
            </div>
          </div>
          <div className="border d-flex flex-column" style={{ maxWidth: "25rem" }} border>
            <div className="p-3">
              <h4 className="mt-3">Heading</h4>
              <p>Paragraph</p>
            </div>
            <CDBView>
              <CDBIframe src="https://www.youtube.com/embed/xnczyP2jSR0"></CDBIframe>
            </CDBView>
            <div className="p-3">
              <CDBBtn color="light" flat circle>
                Button
              </CDBBtn>
            </div>
          </div>
        </div>
      </div>
    </div>
      </Layout>
    </div>
  );
};
